import { Inject, Injectable } from '@angular/core';

import { APPLICATION_WINDOW } from 'src/app/app.constants';

@Injectable()
export class CookieService {

  protected static cookieSuffix: string = ' ;path=';
  protected static forcedCookieExpiration: string = '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=';
  protected static keyExceptions: string[] = [
    'rememberMe'
  ];

  constructor(@Inject(APPLICATION_WINDOW) protected window: Window) {}

  /**
   * Clears all cookies
   */
  public clearAll(): void {
    const document = this.window.document;
    
    document.cookie.split('; ').forEach((cookie) => {
      const domainChunks = window.location.hostname.split('.');

      while (domainChunks?.length) {
        const cookieChunks = cookie.split(';')[0];
        const cookieKey = cookieChunks.split('=')[0];

        if (CookieService.keyExceptions.indexOf(cookieKey) === -1) {
          const cookieBase = (
            encodeURIComponent(cookieKey) + CookieService.forcedCookieExpiration +
            domainChunks.join('.') + CookieService.cookieSuffix
          );
          const pathnameChunks = location.pathname.split('/');

          document.cookie = cookieBase + '/';

          while (pathnameChunks?.length) {
            document.cookie = cookieBase + pathnameChunks.join('/');
            pathnameChunks.pop();
          }
        }

        domainChunks.shift();
      }
    });
  }
}
